import React from 'react';

const Corner = ({ className }) => (
  <svg viewBox="0 0 48 48" className={`filigree-corner ${className}`} fill="none" stroke="currentColor" strokeWidth="1" aria-hidden>
    <path d="M1 47 V14 Q1 1 14 1 H47" />
    <path d="M7 47 V19 Q7 7 19 7 H47" opacity=".4" />
    <circle cx="14" cy="14" r="1.5" fill="currentColor" stroke="none" />
    <path d="M1 32 l2.5 -2.5 l2.5 2.5 l-2.5 2.5 z" fill="currentColor" stroke="none" opacity=".85" />
    <path d="M32 1 l2.5 2.5 l-2.5 2.5 l-2.5 -2.5 z" fill="currentColor" stroke="none" opacity=".85" />
  </svg>
);

export const Filigree = ({ className = '' }) => (
  <div className={`pointer-events-none absolute inset-0 text-[#C8A45D]/60 ${className}`} aria-hidden>
    <Corner className="top-0 left-0" />
    <Corner className="top-0 right-0 -scale-x-100" />
    <Corner className="bottom-0 left-0 -scale-y-100" />
    <Corner className="bottom-0 right-0 -scale-x-100 -scale-y-100" />
  </div>
);

export const StarDivider = ({ className = '' }) => (
  <div className={`flex items-center justify-center gap-3 text-[#C8A45D] ${className}`} aria-hidden>
    <span className="h-px w-10 md:w-14 bg-current opacity-60" />
    <svg viewBox="0 0 24 24" className="w-3.5 h-3.5" fill="currentColor">
      <path d="M12 1 L13.6 10.4 L23 12 L13.6 13.6 L12 23 L10.4 13.6 L1 12 L10.4 10.4 Z" />
    </svg>
    <span className="h-px w-10 md:w-14 bg-current opacity-60" />
  </div>
);

export const Sparkle = ({ x, y, size, dur, delay, className = '' }) => (
  <svg
    viewBox="0 0 24 24"
    className={className}
    style={{ left: `${x}%`, top: `${y}%`, '--tw-size': size, '--tw-dur': `${dur}s`, '--tw-delay': `${delay}s` }}
    aria-hidden
  >
    <path d="M12 0 C12.6 8 16 11.4 24 12 C16 12.6 12.6 16 12 24 C11.4 16 8 12.6 0 12 C8 11.4 11.4 8 12 0 Z" fill="#F6DFA6" />
    <path d="M12 5 C12.3 10 14 11.7 19 12 C14 12.3 12.3 14 12 19 C11.7 14 10 12.3 5 12 C10 11.7 11.7 10 12 5 Z" fill="#FFF8E6" transform="rotate(45 12 12)" opacity="0.8" />
    <circle cx="12" cy="12" r="1.8" fill="#FFFFFF" />
  </svg>
);
